<template>
    <div>
        <div class="iclassreport-body" v-if="showReport">
            <table class="iclassreport-table">
                <thead>
                    <tr>
                        <th>{{  $t('correct_question') }}</th>
                        <th>{{  $t('status') }}</th>
                        <th v-for="(question, index) in presentData" :key="index">
                            {{ "Q" + (index + 1) }}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>{{ totalCorrect }}/{{ totalQuestion }}</td>
                        <td :class="finalResult.color">{{ $t(finalResult.status) }}</td>
                        <td v-for="(score, index) in questionData" :key="index">
                            <template v-if="score !== -1">
                                <template v-if="score > 0">
                                    <svg width="13" height="12" viewBox="0 0 13 12" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M11.5 0H1.5C1.23486 0.000261765 0.980662 0.105703 0.793182 0.293182C0.605703 0.480662 0.500262 0.734864 0.5 1V11C0.500262 11.2651 0.605703 11.5193 0.793182 11.7068C0.980662 11.8943 1.23486 11.9997 1.5 12H11.5C11.7651 11.9997 12.0193 11.8943 12.2068 11.7068C12.3943 11.5193 12.4997 11.2651 12.5 11V1C12.4997 0.734864 12.3943 0.480662 12.2068 0.293182C12.0193 0.105702 11.7651 0.0002616 11.5 0ZM9.59521 4.86133L5.92822 8.36133C5.83533 8.45032 5.71165 8.5 5.58301 8.5C5.45436 8.5 5.33069 8.45032 5.23779 8.36133L3.40479 6.61133C3.3572 6.56603 3.31902 6.51179 3.29242 6.45171C3.26583 6.39164 3.25134 6.32691 3.24978 6.26123C3.24823 6.19555 3.25964 6.13021 3.28336 6.06894C3.30709 6.00767 3.34266 5.95169 3.38804 5.90419C3.43343 5.85668 3.48774 5.81859 3.54786 5.7921C3.60798 5.76561 3.67273 5.75123 3.73841 5.74979C3.8041 5.74835 3.86942 5.75987 3.93064 5.7837C3.99187 5.80754 4.04779 5.8432 4.09522 5.88867L5.58301 7.30859L8.90478 4.13867C8.95221 4.0932 9.00813 4.05754 9.06936 4.0337C9.13058 4.00987 9.1959 3.99835 9.26159 3.99979C9.32727 4.00123 9.39202 4.01561 9.45214 4.0421C9.51226 4.06859 9.56657 4.10668 9.61195 4.15419C9.65734 4.20169 9.69291 4.25767 9.71664 4.31894C9.74036 4.38021 9.75177 4.44555 9.75022 4.51123C9.74866 4.57691 9.73417 4.64164 9.70757 4.70171C9.68098 4.76179 9.64279 4.81603 9.59521 4.86133H9.59521Z"
                                            fill="#28A745" />
                                    </svg>
                                </template>
                                <template v-else>
                                    <svg width="13" height="12" viewBox="0 0 13 12" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M11.5 0H1.5C1.23486 0.000261765 0.980662 0.105703 0.793182 0.293182C0.605703 0.480662 0.500262 0.734864 0.5 1V11C0.500262 11.2651 0.605703 11.5193 0.793182 11.7068C0.980662 11.8943 1.23486 11.9997 1.5 12H11.5C11.7651 11.9997 12.0193 11.8943 12.2068 11.7068C12.3943 11.5193 12.4997 11.2651 12.5 11V1C12.4997 0.734864 12.3943 0.480662 12.2068 0.293182C12.0193 0.105702 11.7651 0.0002616 11.5 0ZM8.85352 7.64648C8.90002 7.69289 8.93692 7.74801 8.96211 7.80869C8.9873 7.86936 9.00029 7.93441 9.00032 8.00011C9.00036 8.06581 8.98744 8.13087 8.96232 8.19158C8.93719 8.25228 8.90035 8.30744 8.85389 8.35389C8.80744 8.40035 8.75228 8.43719 8.69158 8.46232C8.63087 8.48744 8.56581 8.50036 8.50011 8.50032C8.43441 8.50029 8.36936 8.4873 8.30869 8.46211C8.24801 8.43692 8.19289 8.40002 8.14648 8.35352L6.5 6.70703L4.85352 8.35352C4.75972 8.44711 4.63261 8.49964 4.50011 8.49957C4.36761 8.4995 4.24055 8.44683 4.14686 8.35314C4.05317 8.25945 4.0005 8.13239 4.00043 7.99989C4.00036 7.86739 4.05289 7.74028 4.14648 7.64648L5.79297 6L4.14648 4.35352C4.05289 4.25972 4.00036 4.13261 4.00043 4.00011C4.0005 3.86761 4.05317 3.74055 4.14686 3.64686C4.24055 3.55317 4.36761 3.5005 4.50011 3.50043C4.63261 3.50036 4.75972 3.55289 4.85352 3.64648L6.5 5.29297L8.14648 3.64648C8.24028 3.55289 8.36739 3.50036 8.49989 3.50043C8.63239 3.5005 8.75945 3.55317 8.85314 3.64686C8.94683 3.74055 8.9995 3.86761 8.99957 4.00011C8.99964 4.13261 8.94711 4.25972 8.85352 4.35352L7.20703 6L8.85352 7.64648Z"
                                            fill="#F04B25" />
                                    </svg>
                                </template>
                            </template>
                            <template v-else>
                                <span>-</span>
                            </template>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="comment" :class="finalResult.color">
                <span class="status0">{{  $t('feedback_sugest') }}: </span>{{  $t(finalResult.comment) }}
            </div>
        </div>
        <div v-else>
            <div class="status0 p-5">{{  $t('no_data_report_content') }}</div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        presentData: {
            type: Array,
            required: true,
        },
        isActive: {
            type: Boolean,
            require: true
        }
    },
    computed: {
        finalResult() {
            if (this.percentage < 0.4) {
                return {status: 'need_more_effort', color: 'status1', comment: 'presentation_session_comment_need_more_effort'};
            } else if (this.percentage < 0.8) {
                return {status: 'well_done', color: 'status3', comment: 'presentation_session_comment_well_done'};
            } else {
                return {status: 'outstanding', color: 'status4', comment: 'presentation_session_comment_outstanding'};
            }
        },
    },
    methods: {
        parseScore(value) {
            if (!value || value === "-") return 0;
            const num = parseFloat(value);
            return isNaN(num) ? 0 : num;
        },
        formatScore(value) {
            return Math.round(value * 2) / 2;
        },
    },
    mounted() {
        if (this.presentData && this.presentData.length && this.isActive) {
            this.showReport = true;
            for (const item of this.presentData) {
                this.maxPoint += item.point;
                if (item.answers && item.answers.length) {
                    let sum = 0;
                    for (const answer of item.answers) {
                        sum += answer.point;
                    }
                    if (sum == item.point) {
                        sum = this.formatScore(sum);
                        this.totalScore += sum;
                        this.totalCorrect += 1;
                        this.questionData.push(sum);
                    } else {
                        this.questionData.push(0);
                    }
                } else {
                    this.questionData.push(-1);
                }
            }
            this.totalQuestion = this.questionData.length;
            this.totalScore = this.formatScore(this.totalScore);
            this.percentage = this.totalCorrect / this.totalQuestion;
        }
    },
    data() {
        return {
            showReport: false,
            questionData: [],
            percentage: 0,
            totalScore: 0,
            totalQuestion: 0,
            totalCorrect: 0,
            maxPoint: 0,
        };
    },
};
</script>

<style scoped>
.iclassreport-body {
    margin: 20px 77px;
}

.toggle-arrow {
    font-size: 5px;
}

.iclassreport-table {
    margin: 0 auto;
    border-collapse: collapse;
    background: #fff;
    color: #000;
}

/* .iclassreport-table th:first-child,
.iclassreport-table td:first-child {
    width: 250px;
    text-align: left;
} */

.iclassreport-table th,
.iclassreport-table td {
    border: 1px solid #2F66C9;
    padding: 8px;
    text-align: center;
    font-size: 14px;
}

.status0 {
    text-align: center;
    font-size: 14px;
    font-weight: bold;
    color: #000000;
}

.status1 {
    color: #FF0000;
    font-weight: bold;
}

.status2 {
    color: #7158C2;
    font-weight: bold;
}

.status3 {
    color: #FFA800;
    font-weight: bold;
}

.status4 {
    color: #28A745;
    font-weight: bold;
}

.correct-answer {
    color: green;
    font-weight: bold;
}

.almost-answer {
    color: yellow;
    font-weight: bold;
}

.wrong-answer {
    color: red;
    font-weight: bold;
}

.comment {
    font-size: 14px;
    font-weight: bold;
    margin-top: 20px;
    text-align: center;
}
</style>